import React from 'react';
import { i18n } from 'config/locales';

import { LEGAL, LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION } from 'config/formSections/legal';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Field from 'components/Form/Field';
import Textarea from 'components/Form/Textarea';

const sectionConfig = {
  key: LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION.name,
  storeKey: LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION.storeKey,
};

export class TerrorismAssociation extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.updateBranch = this.updateBranch.bind(this);
    this.updateExplanation = this.updateExplanation.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      Explanation: this.props.Explanation,
      HasTerrorism: this.props.HasTerrorism,
      ...queue,
    });
  };

  updateExplanation = (values) => {
    this.update({
      Explanation: values,
    });
  };

  updateBranch = (values) => {
    this.update({
      HasTerrorism: values,
      Explanation: values.value === 'Yes' ? this.props.Explanation : {},
    });
  };

  render() {
    return (
      <div
        className="section-content legal-associations-terrorism"
        data-section={LEGAL.key}
        data-subsection={LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION.key}
      >
        <h1 className="section-header">
          {i18n.t('legal.subsection.associations.terrorismAssociation')}
        </h1>
        <Branch
          attribute="HasTerrorism"
          name="has_terrorsim"
          label={i18n.t('legal.associations.terrorism.heading.title')}
          labelSize="h4"
          className="legal-associations-terrorism-has-terrorism"
          {...this.props.HasTerrorism}
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateBranch} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
        />

        <Show when={this.props.HasTerrorism.value === 'Yes'}>
          <Field
            attribute="Explanation"
            title={i18n.t('legal.associations.terrorism.heading.explanation')}
            adjustFor="textarea"
            scrollIntoView={this.props.scrollIntoView}
          >
            <Textarea
              attribute="Explanation"
              name="Explanation"
              {...this.props.Explanation}
              className="legal-associations-terrorism-explanation"
              onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
              required={this.props.required}
              onUpdate={this.updateExplanation} // eslint-disable-line @typescript-eslint/unbound-method
            />
          </Field>
        </Show>
      </div>
    );
  }
}

TerrorismAssociation.defaultProps = {
  name: 'terrorism',
  HasTerrorism: {},
  defaultState: true,
  onUpdate: () => {},
  onError: (value, arr) => arr,
  section: 'legal',
  subsection: 'associations/terrorism-association',
  dispatch: () => {},
  errors: [],
};

export default connectSubsection(TerrorismAssociation, sectionConfig);
